import React from 'react';

import { groupBy as groupArray } from 'app/shared/utils/array';

import MenuHeader from './MenuHeader';
import SimpleOptions from './Simple';
import { OptionsListProps } from './';

interface Props<T> extends OptionsListProps<T> {
  qaId?: string;
  options: T[];
  onOptionClick: (option: T) => void;
  groupBy: (option: T) => string;
  groupNames?: string[];
}

const GroupedOptions = <T = any,>({
  options,
  groupBy,
  groupNames,
  qaId,
  ...rest
}: Props<T>) => {
  const groups = groupArray(options, groupBy);
  const sortedGroups = groupNames
    ? Object.entries(groups).sort(
        (a: Record<string, any>, b: Record<string, any>) =>
          groupNames.indexOf(a[0]) - groupNames.indexOf(b[0])
      )
    : Object.entries(groups);

  return (
    <>
      {sortedGroups.map((group: Record<string, any>) => (
        <div key={`group-${group[0]}`} data-qaid={`${qaId}-group`}>
          <MenuHeader data-qaid={`${qaId}-group-${group[0]}-header`}>
            {group[0]}
          </MenuHeader>

          <SimpleOptions
            options={group[1]}
            {...rest}
            qaId={`${qaId}-group-${group[0]}`}
          />
        </div>
      ))}
    </>
  );
};

export default GroupedOptions;
